import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import BrandMark from "./BrandMark";

const navItems = [
  ["Company", "company"],
  ["Business", "business"],
  ["AI", "ai"],
  ["Work", "work"],
  ["KAI LAB", "https://kailab.in/", true],
  ["Insights", "insights"],
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [location]);
  useEffect(() => {
    document.body.classList.toggle("nav-open", open);
    return () => document.body.classList.remove("nav-open");
  }, [open]);

  return (
    <header className={`site-header${scrolled ? " is-scrolled" : ""}`}>
      <div className="site-header__inner">
        <Link className="site-header__brand" to="/" aria-label="Crovian home">
          <BrandMark />
        </Link>

        <nav className={`site-nav${open ? " is-open" : ""}`} aria-label="Primary navigation">
          <div className="site-nav__links">
            {navItems.map(([label, destination, external]) => (
              <a
                key={destination}
                href={external ? destination : `/#${destination}`}
                target={external ? "_blank" : undefined}
                rel={external ? "noopener noreferrer" : undefined}
              >
                {label}
              </a>
            ))}
          </div>
          <Link className="header-contact" to="/contact">Contact <span aria-hidden="true">→</span></Link>
        </nav>

        <button
          className={`menu-toggle${open ? " is-open" : ""}`}
          type="button"
          onClick={() => setOpen((value) => !value)}
          aria-expanded={open}
          aria-label={open ? "Close menu" : "Open menu"}
        >
          <span />
          <span />
        </button>
      </div>
    </header>
  );
}
